import React, { useEffect, useState, useRef, useCallback } from 'react';
import { DidomiSDK } from '@didomi/react';
import { useQuery } from '@apollo/client';
import { apiKey } from './didomiConfig';
import { createRoot } from 'react-dom/client';
import NoticeHTML from './noticeHTML';
import { INITIAL_QUERY } from '../query';
import { noticeID } from '../constants';
export const Didomi = ({ onConsentChanged, didomiNoticeId, onReady }) => {
    const [didomi, setDidomi] = useState();
    const [notice, setNotice] = useState();
    const [userId, setUserId] = useState();
    const [isConfigReady, setIsConfigReady] = useState(false);
    const noticeElementRef = useRef(null);
    useQuery(INITIAL_QUERY, {
        onCompleted: (data) => {
            var _a;
            setUserId((_a = data === null || data === void 0 ? void 0 : data.profile) === null || _a === void 0 ? void 0 : _a.userId);
        },
        onError: (err) => {
            console.error(err.message);
        },
    });
    useEffect(() => {
        if (userId) {
            setIsConfigReady(true);
            return;
        }
        const timer = setTimeout(() => {
            setIsConfigReady(true);
        }, 1000);
        return () => clearTimeout(timer);
    }, [userId]);
    const renderNotice = useCallback((element, noticeContent) => {
        const root = createRoot(element);
        root.render(React.createElement(NoticeHTML, { noticeText: noticeContent }));
    }, []);
    useEffect(() => {
        if (didomi && noticeElementRef.current && notice) {
            renderNotice(noticeElementRef.current, notice);
            didomi.notice.show();
        }
    }, [didomi, notice, renderNotice, isConfigReady]);
    return (React.createElement("div", null, isConfigReady && (React.createElement(DidomiSDK, { apiKey: apiKey, config: Object.assign(Object.assign({}, (userId && {
            user: {
                organizationUserId: userId.toString(),
            },
        })), { notice: {
                content: {
                    html: {
                        fr: (element) => {
                            noticeElementRef.current = element;
                            if (notice) {
                                renderNotice(element, notice);
                            }
                        },
                    },
                },
            } }), onConsentChanged: onConsentChanged, noticeId: didomiNoticeId || noticeID, onReady: (result) => {
            var _a, _b, _c;
            if (onReady) {
                onReady();
            }
            setDidomi(result);
            const didomiConfig = result.getConfig();
            const noticeContent = (_c = (_b = (_a = didomiConfig === null || didomiConfig === void 0 ? void 0 : didomiConfig.notice) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.notice) === null || _c === void 0 ? void 0 : _c.fr;
            setNotice(noticeContent);
        } }))));
};
